<div
  class="vendor-barcode-scanner__overlay"
  *ngIf="isVisible"
  (click)="onOverlayClick($event)"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="title"
>
  <div class="vendor-barcode-scanner__container" (click)="$event.stopPropagation()">
    <header class="vendor-barcode-scanner__header">
      <h2 class="vendor-barcode-scanner__title">{{ title }}</h2>
      <button
        type="button"
        class="vendor-barcode-scanner__close"
        (click)="onClose()"
        [disabled]="isProcessing || isDecodingUpload"
        aria-label="Close"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 5L5 15M5 5L15 15"
            stroke="#15172E"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </header>

    <div class="vendor-barcode-scanner__body">
      <p class="vendor-barcode-scanner__hint">{{ hintText }}</p>

      <!-- Mobile / tablet: live camera scan -->
      <div class="vendor-barcode-scanner__viewport" *ngIf="supportsLiveCameraPreview">
        <video
          #video
          class="vendor-barcode-scanner__video"
          playsinline
          [attr.webkit-playsinline]="true"
          muted
          autoplay
        ></video>
        <div
          class="vendor-barcode-scanner__frame"
          *ngIf="!hideUploadControls"
          aria-hidden="true"
        ></div>
        <button
          *ngIf="showTorchToggle"
          type="button"
          class="vendor-barcode-scanner__torch"
          [class.vendor-barcode-scanner__torch--on]="isTorchOn"
          [attr.aria-pressed]="isTorchOn"
          [attr.aria-label]="torchLabel"
          (click)="onToggleTorchClick()"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M13 2 4 14h6l-1 8 9-12h-6l1-8Z"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <div
          class="vendor-barcode-scanner__loader vendor-barcode-scanner__loader--overlay"
          *ngIf="isBusy"
          role="status"
        >
          <div class="vendor-barcode-scanner__spinner" aria-hidden="true"></div>
          <p class="vendor-barcode-scanner__loader-text">{{ loaderMessage }}</p>
        </div>
      </div>

      <!-- Desktop / upload-only -->
      <div class="vendor-barcode-scanner__upload-panel" *ngIf="!supportsLiveCameraPreview">
        <ng-container *ngIf="!hideUploadControls; else desktopLoader">
          <button
            type="button"
            class="vendor-barcode-scanner__upload-panel-btn"
            (click)="supportsCameraScan ? onCaptureClick() : onUploadClick()"
          >
            {{ uploadButtonLabel }}
          </button>
          <p class="vendor-barcode-scanner__upload-panel-hint">PNG, JPG, or WEBP</p>
        </ng-container>
        <ng-template #desktopLoader>
          <div class="vendor-barcode-scanner__loader" role="status">
            <div class="vendor-barcode-scanner__spinner" aria-hidden="true"></div>
            <p class="vendor-barcode-scanner__loader-text">{{ loaderMessage }}</p>
          </div>
        </ng-template>
      </div>

      <p *ngIf="errorMessage" class="vendor-barcode-scanner__error" role="alert">
        {{ errorMessage }}
      </p>
      <button
        *ngIf="showCameraFallbackActions"
        type="button"
        class="vendor-barcode-scanner__retry"
        (click)="onRetryCameraClick()"
      >
        Try camera again
      </button>
    </div>

    <footer class="vendor-barcode-scanner__footer">
      <button
        type="button"
        class="vendor-barcode-scanner__cancel"
        (click)="onClose()"
        [disabled]="isProcessing || isDecodingUpload"
      >
        Cancel
      </button>
      <input
        #fileInput
        type="file"
        accept="image/*"
        hidden
        (change)="onBarcodeFileSelected($event)"
      />
      <input
        #captureInput
        type="file"
        accept="image/*"
        capture="environment"
        hidden
        (change)="onBarcodeFileSelected($event)"
      />
      <button
        *ngIf="showCameraFallbackActions"
        type="button"
        class="vendor-barcode-scanner__upload"
        (click)="onCaptureClick()"
        [disabled]="isProcessing || isDecodingUpload"
      >
        Take photo
      </button>
      <button
        *ngIf="supportsLiveCameraPreview && !showCameraFallbackActions"
        type="button"
        class="vendor-barcode-scanner__upload"
        (click)="onUploadClick()"
        [disabled]="isProcessing || isDecodingUpload"
      >
        Upload barcode
      </button>
      <button
        *ngIf="supportsCameraScan && !supportsLiveCameraPreview && !showCameraFallbackActions"
        type="button"
        class="vendor-barcode-scanner__upload vendor-barcode-scanner__upload--secondary"
        (click)="onUploadClick()"
        [disabled]="isProcessing || isDecodingUpload"
      >
        Upload
      </button>
      <button
        *ngIf="showCameraFallbackActions"
        type="button"
        class="vendor-barcode-scanner__upload vendor-barcode-scanner__upload--secondary"
        (click)="onUploadClick()"
        [disabled]="isProcessing || isDecodingUpload"
      >
        Upload
      </button>
    </footer>
  </div>
</div>
